export enum TaskViewState {
  CREATE = 1,
  EDIT,
  PREVIEW,
}
